module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns-house_access_02-d893e263e2d4f21f9b69afa3b11993fd.jpg";